export default __webpack_public_path__ + "static/media/ad-web-vill-01.74babf14.jpg";